// extracted by mini-css-extract-plugin
export default {"IPhoneApp":"IPhoneApp_IPhoneApp__aOFmz"};